import { System } from '../models/system-overview.model';
import {environment} from '../../environments/environment';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {FeedbackInfo} from '../models/feedback.model';
import {SupportRequestModel} from '../models/support-request.model';

const API_URL = environment.apiUrl;
const API_URL_V2 = environment.apiUrlV2;

@Injectable({
    providedIn: 'root'
})
export class SystemsOverviewService {

    constructor(private http: HttpClient){
    }

    public getByCustomerid(id): Observable<System[]> {

        let url = API_URL + '/equi-list/' + id;
        console.log('SystemsOverviewService: ' + url);

        return this.http.get<System[]>(url);
    }

    public async getRegistrationStatus(id): Promise<number> {

        let url = API_URL + '/equi-list/' + id + '/registrationStatus';
        console.log('SystemsOverviewService: ' + url);

        return this.http.get<number>(url).toPromise();
    }

    sendEmail(feedbackInfo: FeedbackInfo): Observable<any> {

        const url = API_URL + '/mail/feedback';
        console.log('SystemsOverviewService: ' + url, feedbackInfo);

        let httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json', }), responseType: 'text' as 'json' };
        return this.http.post<any>(url, feedbackInfo,  httpOptions);
    }

    createSupportRequest(supportRequest: SupportRequestModel) {

        const url = API_URL_V2 + '/b2b/support/request';
        console.log('SystemsOverviewService: ' + url, supportRequest);

        let httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json', }), responseType: 'text' as 'json' };
        return this.http.post<any>(url, supportRequest,  httpOptions);

    }
}
